import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss'],
})
export class ConfirmComponent implements OnInit {
  public reason: string = '';
  get title(): string {
    return this.data?.title || 'Confirmar eliminación';
  }

  constructor(
    private readonly dialogRef: MatDialogRef<ConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {}

  close(response: boolean) {
    // If the dialog was opened requesting a reason, return an object with the reason
    if (this.data?.showReasonField) {
      if (response) {
        this.dialogRef.close({ confirmed: true, reason: this.reason });
      } else {
        this.dialogRef.close(false);
      }
      return;
    }
    this.dialogRef.close(response);
  }
}
